module.exports = __webpack_public_path__ + "static/media/expression-1.5ec517ee.png";